import { useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { ApiBaseRoute } from '@app/services/consts';

export const useUnsubscribe = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const params = useParams();
  const unsubscribeToken = params.token;

  const performUnsubscribe = async () => {
    if (!unsubscribeToken) {
      setError('Missing required parameters');
      return;
    }

    setIsLoading(true);
    setError(null);


    try {
      // Use direct axios instance to avoid auth redirects
      const response = await axios.post(`${ApiBaseRoute}/unsubscribe`, {token: unsubscribeToken}, {});

      if (response.status === 200) {
        setIsSuccess(true);
      } else {
        console.log(response);
        setError('Failed to unsubscribe');
      }
    } catch (err: any) {
      console.error('Unsubscribe error:', err);
      setError(err?.response?.data?.message || 'Failed to unsubscribe');
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    isSuccess,
    error,
    performUnsubscribe,
  };
};